import Vue from 'vue';

Vue.component('sorting-component', {
    props: {
        defaultUrl: {
            type: String
        }
    },

    data() {
        return {
            sortingUrl: null,
        }
    },

    mounted() {
        this.sortingUrl = this.defaultUrl;
    },

    methods: {
        setSortingUrl() {
            if (!this.sortingUrl) {
                return;
            }

            window.location = this.sortingUrl;
        }
    },

    beforeDestroy() { }
});
